import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap-v5';
import CurrencyFormat from 'react-currency-format';
import { toast } from 'react-toastify';
import zIndex from '@material-ui/core/styles/zIndex';
import { Formik, FormikProps, FormikValues } from 'formik';
import * as Yup from 'yup';
import { useCreateEmail, useRegistrationPreCreate } from '../services';

type Props = {
  show: boolean;
  handleClose: Function;
  refetch: Function;
  initialDate: any;
  organisation_typeList: any;
  areasList: any;
  className?: string; // Yeni prop eklendi
};

export default function PreRegistration({ show, handleClose, organisation_typeList, refetch, initialDate, areasList, className }: Props) {
  const formikRef = useRef<FormikProps<any>>(null);
  const [isParent, setIsParent] = useState<boolean>(false);
  const registrationSchema = Yup.object().shape({
    date_of_organisation: Yup.string().required('Lütfen organizasyon tarihini belirtin.'),
    name_lastname: Yup.string().min(3, 'Minimum 3 karakter girin').max(50, 'Maksimum 50 karakter girin').required('Lütfen adı soyadı belirtin.'),
    phone: Yup.object().shape({
      floatValue: Yup.string().min(1).required(),
      formattedValue: Yup.string().min(1).required(),
      value: Yup.string().min(1).required(),
    }),

    typeof_organisation: Yup.string().test('values', 'message', (value, validationContext) => {
      const { createError, parent } = validationContext;
      if (parent.typeof_organisation == 0 || organisation_typeList?.filter((e: any) => e.id == parent.typeof_organisation).length === 0) {
        return createError({ message: 'Lütfen organizasyon türünü seçin' });
      }
      return true;
    }),
    area: Yup.string(),

    organisation_fee: Yup.object().shape({
      floatValue: Yup.string().min(1),
      formattedValue: Yup.string().min(1),
      value: Yup.string().min(1),
    }),

    notes: Yup.string(),
  });
  const onErrorFetch = (e: any) => e?.response?.data?.message && toast.error(e?.response?.data?.message);
  const onSuccessFetch = (e: any) => {
    toast.success(`${formikRef.current?.values?.date_of_organisation} tarihine ${formikRef.current?.values?.name_lastname} kişisi başarıyla ön kaydı yapıldı.`);
    dissmisLocation();
    refetch();
  };

  const { isLoading: preIsLoading, mutate: preMutate, reset: resetMutate } = useRegistrationPreCreate(onErrorFetch, onSuccessFetch);
  const { isLoading: createEmailIsLoading, mutate: createEmailMutate, data: createEmailData } = useCreateEmail(onErrorFetch);

  const dissmisLocation = () => {
    formikRef?.current?.resetForm();
    handleClose();
  };

  const generateEmail = (isParent: boolean) => {
    setIsParent(isParent);
    const { parent_name_lastname, name_lastname } = formikRef?.current?.values;
    createEmailMutate({ name_lastname: isParent ? parent_name_lastname : name_lastname });
  };

  useEffect(() => {
    if (createEmailData?.data)
      isParent ? formikRef?.current?.setFieldValue('parent_email', createEmailData?.data) : formikRef?.current?.setFieldValue('email', createEmailData?.data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createEmailData?.data]);

  var initialValues = {
    typeof_organisation: 0,
    area: 0,
    organisation_fee: {
      formattedValue: '',
      value: '',
      floatValue: 0,
    },
    notes: '',
    name_lastname: '',
    date_of_organisation: initialDate ? initialDate : '',
    phone: {
      formattedValue: '',
      value: '',
      floatValue: 0,
    },
  };

  return (
    <Modal show={show} onHide={dissmisLocation} centered size="lg" className={className}>
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        validationSchema={registrationSchema}
        onSubmit={(values, { setSubmitting }) => {
          const body = { ...values };
          body.phone = body.phone?.value;
          body.organisation_fee = body.organisation_fee?.value ? body.organisation_fee?.value : -1;
          body.area = body.area ? body.area : -1;
          body.typeof_organisation = body.typeof_organisation ? body.typeof_organisation : -1;

          preMutate(body);
          setSubmitting(false);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting,
          /* and other goodies */
        }) => {
          console.log('errors', errors);
          return (
            <form onSubmit={handleSubmit}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Ön Kayıt Oluştur
                  </h5>
                  <button type="button" className="btn-close" onClick={dissmisLocation} aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  {/*<div className="row mb-5">
                    <div className="col-md-6">
                      <label className="form-label required">T.C Kimlik Numarası</label>
                      <input
                        type="number"
                        name="identity"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.identity}
                        className={`form-control form-control-solid ${errors.identity && touched.identity && 'is-invalid border-danger'}`}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label  required">Adı Soyadı</label>
                      <input
                        type="text"
                        name="name_lastname"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.name_lastname}
                        className={`form-control form-control-solid ${errors.name_lastname && touched.name_lastname && 'is-invalid border-danger'}`}
                      />
                    </div>
                  </div>
                  <div className="row mb-5">
                    <div className="col-md-6">
                      <label className="form-label required">Doğum Tarihi</label>
                      <input
                        type="date"
                        name="date_of_organisation"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.date_of_organisation}
                        className={`form-control form-control-solid ${errors.date_of_organisation && touched.date_of_organisation && 'is-invalid border-danger'}`}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label required">Email</label>
                      <input
                        type="email"
                        name="email"
                        onChange={handleChange}
                        disabled={createEmailIsLoading}
                        onBlur={handleBlur}
                        value={values.email}
                        className={`form-control form-control-solid ${errors.email && touched.email && 'is-invalid border-danger'}`}
                      />
                      <div className="d-flex justify-content-end">
                        <button type="button" className="btn btn-sm btn-link p-0 " onClick={() => generateEmail(false)}>
                          Email Oluştur
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="row mb-5">
                    <div className="col-md-12">
                      <label className="form-label required">Telefon Numarası</label>
                      <CurrencyFormat
                        format="(###) ###-####"
                        mask="_"
                        name={'phone'}
                        onBlur={handleBlur}
                        value={values?.phone?.formattedValue}
                        onValueChange={(e) => formikRef.current?.setFieldValue('phone', e)}
                        className={`form-control form-control-solid ${errors.phone && touched.phone && 'is-invalid border-danger'}`}
                      />
                    </div>
                  </div>
                  <div className="row mb-5">
                    <div className="col-md-12">
                      <label className="form-label required">Sınıfı</label>
                      <select
                        className={`form-select form-select-solid ${errors.class && touched.class && 'is-invalid border-danger'}`}
                        name="class"
                        onChange={(e) => {
                          handleChange(e);
                          setFieldValue('class_branch', 0);
                        }}
                        onBlur={handleBlur}
                        value={values.class}
                      >
                        <option value={''}>Seçiniz</option>
                        {classesList?.map((classes: any, index: number) => (
                          <option key={index} value={classes?.id}>
                            {classes?.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>*/}

                  <div className="row mb-5">
                    <div className="col-md-6 col-xs-12">
                      <label className="form-label required">Organizasyon Türü</label>
                      <select
                        className={`form-select form-select-solid ${errors.typeof_organisation && touched.typeof_organisation && 'is-invalid border-danger'}`}
                        name="typeof_organisation"
                        onChange={(e) => {
                          handleChange(e);
                          setFieldValue('typeof_organisation', e.target.value);
                        }}
                        onBlur={handleBlur}
                        value={values.typeof_organisation}
                      >
                        <option value={''}>Seçiniz</option>
                        {organisation_typeList?.map((classes: any, index: number) => (
                          <option key={index} value={classes?.id}>
                            {classes?.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6 col-xs-12">
                      <label className="form-label">Mekan</label>
                      <select
                        className={`form-select form-select-solid ${errors.area && touched.area && 'is-invalid border-danger'}`}
                        name="area"
                        onChange={(e) => {
                          handleChange(e);
                          setFieldValue('area', 0);
                        }}
                        onBlur={handleBlur}
                        value={values.area}
                      >
                        <option value={''}>Seçiniz</option>
                        {areasList?.map((area: any, index: number) => (
                          <option key={index} value={area?.id}>
                            {area?.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-5">
                    <div className="col-md-6 col-xs-12">
                      <label className="form-label required">Organizasyon Tarihi</label>
                      <input
                        type="date"
                        name="date_of_organisation"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.date_of_organisation}
                        className={`form-control form-control-solid ${errors.date_of_organisation && touched.date_of_organisation && 'is-invalid border-danger'}`}
                      />
                    </div>

                    <div className="col-md-6 col-xs-12">
                      <label className="form-label">Organizasyon Ücreti</label>
                      <CurrencyFormat
                        suffix={'₺'}
                        decimalScale={2}
                        decimalSeparator={','}
                        thousandSeparator={'.'}
                        className={`form-control form-control-solid ${errors.organisation_fee && touched.organisation_fee && 'is-invalid border-danger'}`}
                        name="organisation_fee"
                        value={values?.organisation_fee?.formattedValue}
                        onValueChange={(e) => formikRef.current?.setFieldValue('organisation_fee', e)}
                        onBlur={handleBlur}
                      />
                    </div>
                  </div>
                  <div className="row mb-5">
                    <div className="col-md-6 col-xs-12">
                      <label className="form-label  required">Adı Soyadı</label>
                      <input
                        type="text"
                        name="name_lastname"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.name_lastname}
                        className={`form-control form-control-solid ${errors.name_lastname && touched.name_lastname && 'is-invalid border-danger'}`}
                      />
                    </div>

                    <div className="col-md-6 col-xs-12">
                      <label className="form-label required">Telefon Numarası</label>
                      <CurrencyFormat
                        format="(###) ###-####"
                        mask="_"
                        name={'phone'}
                        onBlur={handleBlur}
                        value={values?.phone?.formattedValue}
                        onValueChange={(e) => formikRef.current?.setFieldValue('phone', e)}
                        className={`form-control form-control-solid ${errors.phone && touched.phone && 'is-invalid border-danger'}`}
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Not</label>
                    <textarea className="form-control form-control-solid" name="notes" onChange={handleChange} onBlur={handleBlur} value={values.notes} rows={3}></textarea>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={dissmisLocation}>
                    Vazgeç
                  </button>
                  <button type="submit" className="btn btn-light-success" disabled={isSubmitting}>
                    Ön Görüşme Kaydı oluştur
                    {preIsLoading && <span className="spinner-border spinner-border-sm align-middle mx-2 text-white"></span>}
                  </button>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </Modal>
  );
}
